<template>
  <div
    class="skeleton skeleton-loader" :class="`${type} ${size}`"
    :style="`${width ? `width: ${width}px;` : ''}${height ? `height: ${height}px;` : ''}`">
  </div>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    default: '',
  },
  height: {
    type: [String, Number],
    default: '',
  },
  size: {
    type: String,
    default: 'medium',
  },
});
</script>

<style lang="scss" scoped>
.text {
  border-radius: 10px;

  &.medium {
    height: 11px;
    width: 100px;
  }
  &.small {
    height: 7px;
    width: 20px;
  }
  &.fullwidth {
    width: 100%;
  }
  &.halfwidth {
    width: 50%;
  }
  &.fullheight {
    height: 100%;
  }
  &.threequarters {
    width: 75%;
  }
}
.avatar {
  border-radius: 32px;

  &.medium {
    height: 32px;
    width: 32px;
  }

  &.small {
    height: 24px;
    width: 24px;
  }
}
.image {
  height: 82px;

  &.medium {
    width: 124px;
    height: 82px;
  }
}
@media screen and (max-width: 600px) {
.text {
  border-radius: 7px;

  &.medium {
    height: 7px;
    width: 65px;
  }
  &.small {
    height: 5px;
    width: 13px;
  }
  &.fullwidth {
    width: 100%;
  }
  &.halfwidth {
    width: 50%;
  }
}
.avatar {
  border-radius: 29px;

  &.medium {
    height: 29px;
    width: 29px;
  }
  &.small {
    height: 16px;
    width: 16px;
  }
}
.image {
  &.medium {
    width: 130px;
    height: 91px;
  }
}
}
@media screen and (min-width: 600px) and (max-width: 1024px)  {

}
@media screen and (min-width: 1024px) and (max-width: 1200px)  {
.image {
  &.medium {
    width: 116px;
    height: 91px;
  }
}
}
</style>
